module.exports = __webpack_public_path__ + "img/wind.730ee032.png";